import { chunkArrayByByteSize, ChunkArrayByByteSizeOptions } from "utils/misc";

type ChunkedData<D extends unknown[]> = {
  [K in keyof D]: Exclude<D[K], null> | undefined;
};

export default function getChunkedTuple<D extends unknown[]>(
  data: [...D],
  options?: Omit<ChunkArrayByByteSizeOptions, "initialByteSizeOffset">,
) {
  const numArrays = data.length;

  let initialByteSizeOffset = 0;

  return data.reduce<ChunkedData<D>[]>((acc, arr, idx) => {
    const [chunks, { lastChunkSize: currentLastChunkSize }] =
      chunkArrayByByteSize(arr as unknown[], {
        ...options,
        initialByteSizeOffset,
      });

    initialByteSizeOffset =
      currentLastChunkSize + (chunks.length > 1 ? 0 : currentLastChunkSize);

    const existingNumChunks = acc.length;

    chunks.forEach((chunk, chunkIdx) => {
      const newChunkIdx = chunkIdx + Math.max(existingNumChunks - 1, 0);
      if (!acc[newChunkIdx])
        acc[newChunkIdx] = Array(numArrays).fill(undefined) as ChunkedData<D>;
      acc[newChunkIdx][idx] = chunk;
    });

    return acc;
  }, []);
}
